import { gql } from "@apollo/client";

export const UPDATED_REASON_FOR_VISIT = gql`
  query fetchReasonsForVisit {
    fetchReasonsForVisit {
      items {
        name,
        options,
      }
    }
  }
`;
